module.exports = __webpack_public_path__ + "static/media/como-funciona-ico-2.abda07b3.svg";